import {GameReelSymbol} from 'src/avalanche/GameReelSymbol';
import {Symbols} from 'src/reels/Symbols';

export class TopReelSymbol extends GameReelSymbol {

	public fixTopReelSymbol(): void {
		this._symbolContainer.visible = true;
		this.container.visible = true;

		if (this.positionOnReel >= 3) {
			if (this.symbolType === Symbols.BN) {
				this.setSymbol(Symbols.TOP_BN);
			} else if (this.symbolType === Symbols.WR) {
				this.setSymbol(Symbols.TOP_WR);
			} else if (this.symbolType === Symbols.RS) {
				this.setSymbol(Symbols.TOP_RS);
			} else {
				if (this.symbolType !== Symbols.TOP_BN
					&& this.symbolType !== Symbols.TOP_WR
					&& this.symbolType !== Symbols.TOP_RS ) {
					this._symbolContainer.visible = false;
				}
			}
		}
	}

	public shouldHaveScatterLandingAnimation(): boolean {
		return false;
	}

	public fixTopReelSymbolBeforeNew(): void {
		this._symbolContainer.visible = true;
		this.container.visible = true;

		if (this.positionOnReel < 3) {
			this.removeIdleAnimation();
			this.container.visible = false;
		} else {
			if (this.symbolType === Symbols.BN) {
				this.setSymbol(Symbols.TOP_BN);
				this.addIdleAnimation();
			} else if (this.symbolType === Symbols.WR) {
				this.setSymbol(Symbols.TOP_WR);
				this.addIdleAnimation();
			} else if (this.symbolType === Symbols.RS) {
				this.setSymbol(Symbols.TOP_RS);
				this.addIdleAnimation();
			} else {
				if (this.symbolType !== Symbols.TOP_BN
					&& this.symbolType !== Symbols.TOP_WR
					&& this.symbolType !== Symbols.TOP_RS) {
					this.removeIdleAnimation();
					this._symbolContainer.visible = false;
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/topreels/TopReelSymbol.ts